module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-regular-593a6820b651df0ad390a490953e3182.woff2";